import type { BillingPaymentProvider } from './billingPaymentRailCopy';
import { isFlutterwaveAbandonedReturn } from './flutterwaveReturn';

export type FlutterwaveBillingReturnParams = {
    status: string;
    transactionId?: string;
    txRef?: string;
};

/** Parse Flutterwave redirect query on Account → Billing. */
export function readFlutterwaveBillingReturnParams(search: string): FlutterwaveBillingReturnParams {
    const params = new URLSearchParams(search);
    const status = (params.get('status') || '').toLowerCase();
    const transactionId = params.get('transaction_id') || params.get('id') || params.get('transactionId') || undefined;
    const txRef = params.get('tx_ref') || params.get('txRef') || params.get('reference') || undefined;
    return { status, transactionId, txRef };
}

/** Saved cards on Billing must match the active rail (stripe | paystack | flutterwave). */
export function paymentMethodMatchesBillingRail(
    card: { source?: string | null },
    provider: BillingPaymentProvider,
): boolean {
    const source = (card.source || 'stripe').toLowerCase();
    return source === provider;
}

/**
 * Whether Billing should call verify-flutterwave-card for this return URL.
 * Abandoned / cancelled returns must not verify.
 */
export function shouldVerifyFlutterwaveBillingReturn(search: string): boolean {
    const params = new URLSearchParams(search);
    if (isFlutterwaveAbandonedReturn(params)) return false;
    const { status, transactionId, txRef } = readFlutterwaveBillingReturnParams(search);
    if (!transactionId && !txRef) return false;
    if (status && status !== 'successful' && status !== 'success' && status !== 'completed') {
        return false;
    }
    return true;
}
